var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMicrophone = function SvgMicrophone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M7.54 11.077q1.269 0 2.172-.904A2.96 2.96 0 0 0 10.616 8V3.077q0-1.269-.904-2.173A2.96 2.96 0 0 0 7.54 0Q6.27 0 5.366.904a2.96 2.96 0 0 0-.904 2.173V8q0 1.269.904 2.173a2.96 2.96 0 0 0 2.173.904"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M12.894 6.336a.6.6 0 0 0-.433-.182q-.249 0-.432.182a.6.6 0 0 0-.183.433v1.23q0 1.78-1.264 3.044t-3.044 1.265q-1.778 0-3.043-1.265Q3.231 9.78 3.231 8V6.769q0-.25-.183-.433a.6.6 0 0 0-.433-.182.6.6 0 0 0-.432.182A.6.6 0 0 0 2 6.77v1.23q0 2.127 1.418 3.698 1.419 1.572 3.505 1.803v1.269H4.462a.6.6 0 0 0-.433.183.6.6 0 0 0-.183.432q0 .25.183.433a.6.6 0 0 0 .433.183h6.153a.6.6 0 0 0 .433-.183.6.6 0 0 0 .183-.433.6.6 0 0 0-.183-.432.6.6 0 0 0-.433-.183H8.154v-1.27q2.086-.23 3.505-1.802Q13.077 10.125 13.077 8V6.769a.6.6 0 0 0-.183-.433"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMicrophone);
export { ForwardRef as ReactComponent };